module.exports = __webpack_public_path__ + "img/team-dark-03.9c4e529e.jpg";